/**
 * fold
 */

import $ from 'jquery';
import Vue from 'vue/dist/vue';
import Page from 'js/lib/page';

import cartItem from '~/cart-item/cart-item';

//@ts-check

export default class ProductHold extends Page {
  init() {
    this.data = {};

    this.elements();
    this.events();

    this.vm = this.vue();
  }
  vue() {
    const scope = this;

    return new Vue({
      el: this.$.root.get(0),
      data: this.data,
      components: {
        'cart-item': cartItem
      }
    });
  }
}

Page.make(ProductHold, '.js-product-hold');
